var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "responsive-image" }, [
    _c(
      "div",
      {
        staticClass: "responsive-image__container",
        style: _vm.containerStyles
      },
      [
        _c("div", { staticClass: "responsive-image__bkg" }, [
          _c("img", {
            directives: [
              {
                name: "lazy",
                rawName: "v-lazy",
                value: _vm.src,
                expression: "src"
              }
            ],
            staticClass: "responsive-image__img",
            class: "responsive-image__img--" + _vm.fit,
            attrs: { alt: _vm.alt, draggable: _vm.draggable }
          })
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }